import React from 'react';

import ProductsCarousel, {
  ProductsCarouselProps,
} from 'components/Common/Carousel/ProductsCarousel/ProductsCarousel';
import { getSlideType } from 'services/carousel';
import { TABLET_PORTRAIT_MAX } from 'settings/device';
import { DefaultCarouselProductType } from 'types/Carousel';

export default function RecentlySeenCarousel(
  props: RecentlySeenCarouselProps
): JSX.Element {
  const productsLength = props.products.length;

  return (
    <ProductsCarousel
      splideOptions={{
        perPage: 6,
        type: getSlideType(6, productsLength),
        breakpoints: {
          [TABLET_PORTRAIT_MAX]: {
            padding: '20%',
            perPage: 1,
            type: getSlideType(1, productsLength),
          },
        },
      }}
      {...props}
    />
  );
}

export type RecentlySeenCarouselProps = Omit<
  ProductsCarouselProps<DefaultCarouselProductType>,
  'splideOptions'
>;
